//@flow
import { createSelector } from 'reselect'
import { getRoot } from './rootSelector'
import type { Filter, PollFilters, FluxStandardAction } from '../types'

// Constants
export const TOGGLE_POLL_FILTER = 'TOGGLE_POLL_FILTER'

// Actions
export const togglePollFilter = (filter: Filter) => ({
  type: TOGGLE_POLL_FILTER,
  payload: {
    [filter.label]: {
      ...filter,
      active: !filter.active,
    },
  },
})

// Selectors
export const getTagFilters = createSelector(
  getRoot,
  ({ pollFilters }) => [pollFilters.automated, pollFilters.sponsored]
)

export const automatedTagSelected = createSelector(
  getRoot,
  ({ pollFilters }) => pollFilters.automated.active
)

// Reducer
const defaultState = {
  automated: {
    label: 'automated',
    active: false,
  },
  sponsored: {
    label: 'sponsored',
    active: false,
  },
}

export default function reducer(
  state: PollFilters = defaultState,
  action: FluxStandardAction
) {
  switch (action.type) {
    case TOGGLE_POLL_FILTER:
      return {
        ...state,
        ...action.payload,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/stores/pollFilters.js